module.exports = __webpack_public_path__ + "images/revo1-67356458cfff1ae6828ce17c221d60bd.jpg";